<template>
  <div
    class="container"
    :class="badgeList[activeIndex]?.light == 1 ? 'container1' : 'container2'"
  >
    <div class="top">
      <div class="top_left" @click="gaback">
        <img src="@/assets/newMedal/time/left2.png" alt="" />
      </div>
      <div class="top_center">{{ badgeItem.medalTypeName }}</div>
      <div class="topRight"></div>
    </div>
    <div class="imgBox">
      <!-- <img class="img2" :src="imgUrl + badgeItem.iconId" alt="" /> -->
      <swiper class="scrollItem" :options="swiperOptions" style="width: 100%">
        <swiper-slide v-for="(item, index) in badgeList" :key="index">
          <div class="img_con">
            <img
              class="img2"
              :src="imgUrl + (item.light == 1 ? item.iconId : item.fileId)"
              alt=""
            />
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <div class="title" v-if="badgeList[activeIndex]?.light == 1">恭喜您</div>
    <div class="title" v-else>未解锁</div>
    <div class="content_label" v-if="badgeList[activeIndex]?.light == 1">
      荣获<span>【{{ badgeList[activeIndex]?.medalName }}】</span>勋章
    </div>
    <div class="unlock_con" v-else>
      {{ badgeList[activeIndex]?.unlockDescribe }}
    </div>
    <div class="date" v-if="badgeList[activeIndex]?.light == 1">
      于{{ badgeList[activeIndex]?.getTime }}点亮勋章
    </div>
    <div class="btn">
      <el-button @click="toDetail(badgeList[activeIndex])">查看详情</el-button>
    </div>
    <div class="logo">
      <img src="../../../../assets/newMedal/time/logo.svg" alt="" />
    </div>
  </div>
</template>

<script>
import api from "@/apis/medal";
import moment from "moment";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  components: {
    swiper,
    swiperSlide
  },
  data() {
    let _this = this;
    return {
      imgUrl: "",
      cardItem: {},
      badgeItem: {},
      activeIndex: 0,
      badgeList: [],
      swiperOptions: {
        loop: true,
        // autoplay: false,
        loopedSlides: 0,
        loopAdditionalSlides: 0,
        slidesPerView: "auto",
        effect: "coverflow",
        centeredSlides: true,
        coverflowEffect: {
          rotate: 0,
          stretch: -20,
          depth: 270,
          modifier: 1,
          slideShadows: false
        },
        on: {
          init: function () {
            _this.cardItem = JSON.parse(localStorage.getItem("cardItem"));
            _this.badgeItem = JSON.parse(localStorage.getItem("badgeItem"));
            const nameIndex = _this.cardItem.medals.findIndex(
              item => item?.medalName == _this.badgeItem?.medalName
            );
            _this.activeIndex = this.realIndex;
            this.activeIndex = nameIndex;
            _this.activeIndex = nameIndex;
          },
          slideChange: function () {
            _this.activeIndex = this.realIndex;
          }
        }
      }
    };
  },
  mounted() {
    this.imgUrl = api.imgUrl;
    this.cardItem = JSON.parse(localStorage.getItem("cardItem"));
    this.badgeItem = JSON.parse(localStorage.getItem("badgeItem"));
    this.badgeList = this.cardItem.medals.map(item => {
      item.getTime = item.getTime
        ? moment(item.getTime).format("YYYY/MM/DD")
        : "";
      return item;
    });
    // this.badgeItem.getTime = moment(new Date(this.badgeItem.getTime)).format(
    //   "YYYY/MM/DD"
    // );
  },
  methods: {
    // 返回上一页
    gaback() {
      localStorage.setItem("tabValue", JSON.stringify(this.cardItem.id));
      this.$router.go(-1);
    },
    //跳转点赞卡详情
    toDetail(info) {
      if (info?.light == 1) {
        this.$router.push({
          path: "/mobile/medal/quaquakaDetail",
          query: {
            id: info?.recordId
          }
        });
      } else {
        return this.$message({
          type: "warning", // success error warning
          message: "您还未获取该点赞卡！",
          duration: 2000
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
.container1 {
  width: 100%;
  height: 100%;
  background: url("~@/assets/newMedal/bg8.png");
  background-size: 100% 100%;
}
.container2 {
  width: 100%;
  height: 100%;
  background: url("~@/assets/newMedal/bg15.png");
  background-size: 100% 100%;
}
.container {
  padding: 60px 0px 30px;
  overflow: hidden;
  position: relative;
  .top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 30px;
    color: #fff;
    margin-top: -20px;
    div {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .top_left {
      margin-left: 30px;
    }
    .top_center {
      // margin-left: -15%;
      margin-right: 30px;
    }
    .topRight {
      width: 50px;
      height: 20px;
    }
  }
  .imgBox {
    // .img2 {
    //   width: 380px;
    //   height: 380px;
    //   position: absolute;
    //   top: 12%;
    //   left: 50%;
    //   transform: translateX(-50%);
    //   z-index: 99;
    // }
    position: absolute;
    top: 6vh;
    width: 100%;
    // margin-top: 7vh;
    .scrollItem {
      width: 100% !important;
      height: 540px;
      display: flex;
      justify-content: center;
    }
    .swiper-slide {
      width: 540px;
      display: flex;
      justify-content: center;
    }
    .swiper-slide-active {
      .img_con {
        opacity: 1 !important;
      }
    }
    .img_con {
      width: 540px;
      height: 540px;
      opacity: 0.38;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .title {
    position: absolute;
    top: 55%;
    left: 50%;
    transform: translateX(-50%);
    font-size: 32px;
    color: #272e3a;
    font-family: MiSans;
    font-weight: bold;
  }
  .content_label {
    position: absolute;
    top: 62%;
    left: 50%;
    transform: translateX(-50%);
    font-size: 34px;
    font-family: MiSans;
    font-weight: bold;
    color: #fff;
    span {
      color: #f1e8c8;
    }
  }
  .unlock_con {
    width: 80%;
    position: absolute;
    top: 62%;
    left: 50%;
    transform: translateX(-50%);
    color: #ffffff;
    font-size: 30px;
    text-align: center;
  }
  .date {
    position: absolute;
    top: 74%;
    left: 50%;
    transform: translateX(-50%);
    font-size: 28px;
    color: #fff;
  }
  .btn {
    position: absolute;
    top: 80%;
    left: 50%;
    transform: translateX(-50%);
    .el-button {
      width: 450px;
      height: 80px;
      background: linear-gradient(0deg, #ecca9b -17%, #f8f0d0 136%);
      border: none;
      border-radius: 100px;
      color: #272e3a;
      font-size: 30px;
      font-weight: bold;
    }
  }
  .logo {
    position: absolute;
    bottom: 4%;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
